import { useQueryClient, useMutation } from "@tanstack/react-query";

import { showToast } from "utils/toast";
import { deleteProject } from "../api/deleteProject";



export const useDeleteProjectMutation=()=>{
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn:deleteProject,

        onError:(error:any)=>{
            if (error.isNetworkError) {
                showToast.error("Network error. Please try again.");
                return;
            }
        
            showToast.error("Something went wrong");
        },

        onSuccess: () => {
            // showToast.success("Project deleted successfully");

            queryClient.invalidateQueries({
                queryKey: ["projects"],
            });
        },


    });

}
